import request from './../config'
import qs from 'qs'
import { ResultProp } from './api.model'
import { useToken, useUser } from '@/hooks/storage'

/* *
 * title: 访客登录
 * methods: POST
 * */
export const GuestToken = () => {
  return request.get('/reserve/getGuestToken')
}
/* *
 * title: 前台登录
 * methods: POST
 * */
export const Login = {
  resUrl: '/mobileCasLogin',
  request: () => {
    window.location.href = request.defaults.baseURL + Login.resUrl
  }
}
/* *
 * title: 微信登录
 * methods: POST
 * */
export const wechatLogin = props => {
  return request.get<ResultProp>('/weChatLogin?' + qs.stringify(props))
}
/* *
 * title: 前台登出
 * methods: POST
 * */
export const Logout = {
  resUrl: '/mobileCasLogout',
  request: () => {
    useUser().clear()
    window.location.href = request.defaults.baseURL + Logout.resUrl
  }
}

/* *
 * title: 前台获取用户信息
 * methods: POST
 * */
export const getLoginUser = {
  resUrl: '/getInfo',
  request: () => {
    return request.get<ResultProp>(getLoginUser.resUrl)
  }
}

/* *
 * title: 新增访客
 * methods: POST
 * */
export interface ActivityProp {
  appApproStatus?: string
  appId?: string
  appInterGh?: string
  appInterName?: string
  appIsComm?: string
  appStatus?: string
  appVistDate?: string
  appVistDept?: string
  appVistIdCard?: string
  appVistName?: string
  appVistNo?: string
  appVistPhone?: string
  appVistResaon?: string
  appInterXQ?: string
  appInterPhone?: string

  approvalState?: string
  employeeGh?: string
  initiatorType?: string
  visitorName: string
  visitCampus?: string
  visitorCompany: string
  idNumber: string
  visitorPhone: string
  visitTimeBegin?: string
  visitTimeEnd?: string
  visitReason?: string
  licensePlate?: string
  identityCode?: string
  id?: string
}
export const activity_add = (props: ActivityProp[]) => {
  return request.post<ResultProp>('/reserve/add', props)
}
/* *
 * title: 获取被访人
 * methods: POST
 * */
export const xustVistUser_list = (props: { fullName: string; phone: string }) => {
  return request.get<ResultProp>('/reserve/searchUser?' + qs.stringify(props))
}

/* *
 * title: 获取访客列表
 * methods: POST
 * */
export const activity_list = (props: any) => {
  return request.get<ResultProp>('/reserve/list?' + qs.stringify(props))
}
/* *
 * title: 获取访客列表
 * methods: POST
 * */
export const activity_list_page = (props: any) => {
  return request.get<ResultProp>('/reserve/listByPage?' + qs.stringify(props))
}
/**
 * title:获取访客记录详情
 * methods:POST
 */
export const record_detail = (props: any) => {
  return request.get<ResultProp>('/reserve/list?' + qs.stringify(props))
}
/**
 * title:获取教师待办
 * methods:POST
 */
export const teacher_backlog = (props: any) => {
  return request.get<ResultProp>('/spWorkHandle/listPage?' + qs.stringify(props))
}
/* *
 * title: 审批
 * methods: POST
 * */
export const approv = (props: any) => {
  return request.post<ResultProp>('/task/formDataSave', props)
}
/* *
 * title: 上传文件
 * methods: POST
 * */
export const uploadFile = (props: any) => {
  return request.post<ResultProp>('/jeecg-boot/sys/common/upload', props, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
/**
 * title:获取校区数据
 **/
export const getFkXiaoQus = () => {
  return request.get<ResultProp>('/system/dict/data/type/v_campus')
}
/**
 * title:获取访客预约访问字段
 */
export const getFkFormItems = () => {
  return request.get<ResultProp>('/system/dict/data/type/fk_col')
}
export const selectJdBasicInfoById = (props: any) => {
  return request.get<ResultProp>(`/jdBasicInfo/selectJdBasicInfoById/${props}`)
}
export const jdVisitorApplylist = (props: any) => {
  return request.get<ResultProp>('/jdVisitorApply/list?' + qs.stringify(props))
}
export const getAuthorizeCode = () => {
  return request.get<ResultProp>('/jdBasicInfo/getAuthorizeCode')
}

export const visiteradd = (props: any) => {
  return request.post<ResultProp>('/jdVisitorApply/add', props)
}
export const getUserBasicInfo = (props: any) => {
  return request.post<ResultProp>('/system/user/getUserBasicInfo', props)
}
export const getUserInfo = () => {
  return request.get<ResultProp>('/getInfo')
}

//  根据访客申请id查询单条数据 接口
export const selectJdVisitorApplyById = (props: any) => {
  return request.get<ResultProp>(`/jdVisitorApply/selectJdVisitorApplyById/${props}`)
}

// 单条审批
export const formDataSave = (props: any) => {
  return request.post<ResultProp>('/task/formDataSave', props)
}
//  根据访客申请id查询单条数据 接口
export const getSpWorkHandleById = (props: any) => {
  return request.get<ResultProp>(`/spWorkHandle/getSpWorkHandleById/${props}`)
}

//  根据访客申请id查询单条数据 接口
export const selectCaApprovalInfoByProWorkHandelId = (props: any) => {
  return request.get<ResultProp>(`/sdApprovalInfo/selectCaApprovalInfoByProWorkHandelId/${props}`)
}
/**车辆入校预约 */
export const getOpenId = (props: any) => {
  return request.get<ResultProp>(`/jdBasicInfo/getOpenId/${props}`)
}

export const selectBasicInfoById = (props: any) => {
  return request.get<ResultProp>(`/jdBasicInfo/selectJdBasicInfoById/${props}`)
}

// 查询全部部门
export const queryAllDept = (props: any) => {
  return request.get<ResultProp>('/system/dept/orglist?' + qs.stringify(props))
}
/**校外车辆入校预约*/
// 用户预约记录
export const carsApplyList = (props: any) => {
  return request.get<ResultProp>('/jdCarsApply/list?' + qs.stringify(props))
}
export const addCarsApply = (props: any) => {
  return request.post<ResultProp>('/jdCarsApply/add', props)
}
export const queryApplyList = (props: any) => {
  return request.get<ResultProp>('/jdVisitorApply/list?' + qs.stringify(props))
}
export const queryApplyInfo = (id: any) => {
  return request.get<ResultProp>(`/jdCarsApply/selectJdCarsApplyById/${id}`)
}
export const approveApply = (props: any) => {
  return request.post<ResultProp>('/jdVisitorApply/add', props)
}
export const queryAllEntrance = (name: any) => {
  return request.get<ResultProp>(`/system/dict/data/type/${name}`)
}
